var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import arrayReduce from 'fast-loops/lib/arrayReduce';
import isPlainObject from 'isobject';

function renderFontFace(fontFace, renderer) {
  if (typeof fontFace === 'string') {
    return fontFace;
  }

  var fontFamily = fontFace.fontFamily,
      src = fontFace.src,
      otherProps = _objectWithoutProperties(fontFace, ['fontFamily', 'src']);

  if (typeof fontFamily === 'string' && Array.isArray(src)) {
    return renderer.renderFont(fontFamily, src, otherProps);
  }

  // TODO: warning - invalid font data
  return undefined;
}

function embedded(style, type, renderer, props) {
  var _loop = function _loop(property) {
    var value = style[property];

    if (property === 'fontFace' && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      if (Array.isArray(value)) {
        style.fontFamily = arrayReduce(value, function (fontFamilyList, fontFace) {
          var fontFamily = renderFontFace(fontFace, renderer);

          if (fontFamily && fontFamilyList.indexOf(fontFamily) === -1) {
            fontFamilyList.push(fontFamily);
          }

          return fontFamilyList;
        }, []).join(',');
      } else {
        style.fontFamily = renderFontFace(value, renderer);
      }
      delete style.fontFace;
    } else if (property === 'animationName' && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      if (Array.isArray(value)) {
        style[property] = value.map(function (frame) {
          return renderer.renderKeyframe(function () {
            return frame;
          });
        }, props).join(',');
      } else {
        style[property] = renderer.renderKeyframe(function () {
          return value;
        }, props);
      }
    } else if (isPlainObject(value)) {
      embedded(value, type, renderer, props);
    }
  };

  for (var property in style) {
    _loop(property);
  }

  return style;
}

export default (function () {
  return embedded;
});